var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.378662,
    width: 15.3786,
    height: 16,
    fill: "url(#pattern0_392_11429)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_392_11429",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_392_11429",
    transform: "scale(0.010101 0.00970874)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_392_11429",
    width: 99,
    height: 103,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABnCAYAAAAUqvyDAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAY6ADAAQAAAABAAAAZwAAAABIidjaAAAEMklEQVR4Ae2c63KkIBCFN1P7/q+8Oz2pTlBA6Suohx/BQejL+WicMpV8/Vm8/Xu3sxC/3u1szhXuL5fEiPgtYe8AZAkYWgB7KFcH8nefUOZnLwiZMUf6mgIDENpIU4+pDAhXPqpSYGRAoL12ZRAU/4t+RLYsEJE5ZNkOe2YAghxhyDE1A8TVjyhC5wpjBoRPEm8S8n243gq3JLJB3KES9tvBBUY0iDsKvwdBn80wokA8BUAJxQQjAsQTITAQNQxPEE8GwCCoV8EAiFJCv2sxDC8QqIYaoggGQNQCeo6EvQ5pBYlqaKnyOzZcGdaqAIhf0XtXQzAAoief7/gpDIDwFfzIWujvM3A0HUlf3zusDEtVAEQt9tlISGUAxJns7fvdytBWBUC0hR4ZDamMEceYUyvQrAxURS1UxohbZeB4suOqYGirwh4KLFQwNJKgKjSq1Ws2MFAVtUCZIxsYGseoCo1q7TVmGG2zGNUo8PPVVnNEoSo0kvfXoDL62qTfUcNAVfiz+sDQHFH+ocCiujIgnb8CKhg4ovxBkEUVjJhQYBUwFtoDLzy816GByliHhfyZgYd3HD1URpy2YsuAIZYsbgFgxGkrtgwYYsniFgBGnLZiy4AhlixuAWDEaSu2DBhiyeIWAEactmLLgCGWLG4BYMRpK7YshoG3vGKNhxeIYQxbxkSxAi+8hRVrFrYAlREmrdywCgaeG3KhR1aoYIwYxhy5Ah8YeG7IhYtYoa4MHFU6HKQbtdbq1P+q0wrgKWN7APy5PJV+/iSAROEJowKVhkbXPHHeiK6kpfqYIlFHnDxR/DJniUYmGKVTXNcKSEDQ3A0MzbEjcViHi5FSgQ2M8gaubQpoNqkLDI1jW6prr9bqUcHQHFUkjTaAtWXNja6Ckev+ft60m7L71RbVMWeTuFeGdmfMSd/XqzZ33vxdGDzBN9z7WtOCKBXpwignSa89ApP6nDnfkm+56TfvploJeTlq2b7DmKc+p5VRkpOKZwlU6mvGfO/8TmFYk/QO2BqP13prXq1NfnpMcfBW52SnFQDbv1Jv1aKnwzAMEssaBNnoBUL3Vm8e+VOOPQ1EMMiQR0C9YMj+qs0jb8rtKPcpMFjwo8B4zgp9BgjKUwyDFnkFR7aorQrFM8+RHFUwSEDPQFcDMis3NYwIIGST2sgu+p7p+9MbgjQXEwxyFpEAS5wBZaX4zTCigTAY6j3gRIpvjdUFBgeRlSj7o74HaEYsHFcvJr7f611hkJOZIvSSzBzXgqAY3WGQ0ScCsUAgzaiFwPg2/RwoHiDCYZCDO1eJFwTevKGVwU7uCMUbBGmUBoPBXL1SIiCwNukw2PHVoERCYE2mweAAVoaSAYB1oH46DA5mJSjZEFiDZWBwQNxnwpklPufK/bIwOEDqvcGsIn6ZI11fAsY+6PJzC9SqYpdxt67/Axk3dIINUZpzAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLoading);
export default __webpack_public_path__ + "static/media/buttonLoading.977163887f548cceb91c4b7847719de4.svg";
export { ForwardRef as ReactComponent };